export enum MonitoringTypes {
  LOAD_REQUEST = "@monitoring/LOAD_REQUEST",
  LOAD_SUCCESS = "@monitoring/LOAD_SUCCESS",
  LOAD_FAILURE = "@monitoring/LOAD_FAILURE",
}
export interface Monitoring {
  data: {
    default_loading_tab: string;
    default_loading_sub_tab: string;
    tabs: {
      id: string;
      label: string;
      active: boolean;
      sub_tabs: {
        id: string;
        label: string;
        url: string;
        active: boolean;
      }[];
    }[];
  };
  message: string;
}

export interface MonitoringState {
  data: Monitoring;
  loading: boolean;
  success: boolean;
  error: boolean;
}

export type LoadRequestParams = Partial<Omit<string | Monitoring, "data">>;
